'use strict';

var $    = require('jquery');
var _    = require('underscore');
var InspectorCore = require('../core/core_inspector.js');

/**
 * Creates an inspector with value and unit
 *
 * @class
 */

class InspectorValueUnit extends InspectorCore {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'title': '',
				'value': '',
				'units': [],
                'tooltip': ''
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__inspector__item editor__inspector__item--single">
				<div class="editor__inspector__item__label" title="<%- tooltip %>"><%- title %></div>
				<input class="editor__inspector__item__textinput editor__inspector__item__textinput--align-right js-inspector__textinput__value" type="text" value="<%- value %>">
        		<select class="editor__inspector__item__select js-inspector__select">
					<% _.each(units, function(i){ %>
						<option value="<%- i %>"><%- i %></option>
					<% }); %>
				</select>
			</div>
		`;

		super.render();

		/**
		* Text input
		*
		* @fires InspectorValueUnit#_valuechanged
		*/
		$('.js-inspector__textinput__value', this.$el).on('input', this._valuechanged);
		$('.js-inspector__textinput__value', this.$el).on('focus', this._focus);
		$('.js-inspector__textinput__value', this.$el).on('blur', this._blur);

		var self = this;
		$('.js-inspector__textinput__value', this.$el).keypress(function(e) {
		    if (e.which == 13) {
		  	    self._enter(e);
		    }
		});

		/**
		* Selectbox
		*
		* @fires InspectorValueUnit#_unitchanged
		*/
		$('.js-inspector__select', this.$el).show();
		$('.js-inspector__select', this.$el).on('change', this._unitchanged);
	}

	/**
     * @event InspectorValueUnit#Cioui:Inspector:value
     * @property {String}Cioui:Inspector:value
     * @returns {String} value - the new text input obj
     */

	_valuechanged(e){
		$(e.currentTarget).trigger('Cioui:Inspector:value', $(e.currentTarget).val());
	}

	/**
     * @event InspectorValueUnit#Cioui:Inspector:unit
     * @property {String}Cioui:Inspector:unit
     * @returns {String} value - the new text input obj
     */

	_unitchanged(e){
		$(e.currentTarget).trigger('Cioui:Inspector:unit', $(e.currentTarget).val());
	}

	/**
     * @event InspectorValueUnit#Cioui:Inspector:focus
     * @property {String}Cioui:Inspector:focus
     * @returns {String} value - the new text input obj
     */
	_focus(e){
		$(e.currentTarget).trigger('Cioui:Inspector:focus', $(e.currentTarget).val());
	}

	/**
     * @event InspectorValueUnit#Cioui:Inspector:focus
     * @property {String}Cioui:Inspector:focus
     * @returns {String} value - the new text input obj
     */
	_blur(e){
		$(e.currentTarget).trigger('Cioui:Inspector:blur', $(e.currentTarget).val());
	}

	/**
     * @event InspectorValueUnit#Cioui:Inspector:enter
     * @property {String}Cioui:Inspector:enter
     * @returns {String} value - the new text input obj
     */
	_enter(e){
        $(e.currentTarget).trigger('Cioui:Inspector:enter', $(e.currentTarget).val());
	}

	/**
	* setValue
	*
	* @param {string} value - the value that you want to set
	*/

	setValue(value){
		$('.js-inspector__textinput__value', this.$el).val(value);
	}

	/**
	* setUnit
	*
	* @param {string} unit - the unit that you want to set
	*/

	setUnit(unit){
		$('.js-inspector__select', this.$el).val(unit);
	}
}
module.exports = InspectorValueUnit;
